
<div class="footer-text">
    <p>&copy; 2024 MARUTI SUZUKI INDIA LIMITED | Powered By - AdGlobal360</p>
</div>